// import { createStore, compose, applyMiddleware } from 'redux';
import { createStore, applyMiddleware } from 'redux';

import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducers from '../Reducers';

import { persistStore } from 'redux-persist'

// agrego Dev Tools Redux
import { composeWithDevTools } from 'redux-devtools-extension';

    // logger
    const middleWare = [];
    // middleWare.push(thunk)
    // const loggerMiddleware = createLogger({
    //   predicate: () => process.env.NODE_ENV === 'development',
    // });
    // middleWare.push(loggerMiddleware)


    // Dev Tools Redux
    const store = createStore(
      reducers,
      {},
      composeWithDevTools(
        applyMiddleware(...middleWare)
      )
    );


export default store;

export const persistor = persistStore(store)


// WEBPACK FOOTER //
// ./src/Store/index.js